import { DatePipe, registerLocaleData } from '@angular/common';
import localeBr from '@angular/common/locales/br';
import { enableProdMode, importProvidersFrom, LOCALE_ID } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RecaptchaModule } from 'ng-recaptcha';

import { AppComponent } from './app/app.component';
import { AppRoutingModule } from './app/app-routing.module';
import { RegisterComponent } from './app/components/register/register.component';
import { SharedModule } from '@shared/shared.module';
import { AssociationUserSocialComponent } from './app/modules/main/components/association-user-social/association-user-social.component';
import { environment } from '@env/environment';

registerLocaleData(localeBr, 'pt-BR');

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      AppRoutingModule,
      BrowserAnimationsModule,
      SharedModule,
      RecaptchaModule,
    ),
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    RegisterComponent,
    AssociationUserSocialComponent,
    DatePipe,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
  .catch(() => undefined);
